import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: PhenologicalStateUpdateInput!
  ) {
    updateOnePhenologicalState(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Estado Fenológico actualizado`, mutationTypes.UPDATE)
)

